<template>
  <div class="webSrom">
    <div class="IMtop">
      <span>{{ textTitle }}</span>
      <div class="history-btn" @click="getVideoLog">历史视频</div>
    </div>
    <el-alert :closable="false" center :title="isRealTime?('会议开始时间：'+createTime):'应急联动聊天'" type="warning"></el-alert>
    <div class="chatFrame" id="chatFrame" ref="chatFrame">
      <div class=" text-center">
        <span v-if='hasMoreInfo' class="MoreNews pointer" @click="messageHistory()">——查看更多消息——</span>
        <span v-else class="MoreNews pointer">没有更多消息了</span>
      </div>
      <div class="" v-for="(item,i) in $store.state.notCompare[groupId]" :key="i">
        <div class="other-msg" v-if="item.type==99">
          <span>{{ new Date($store.state.notCompare[groupId][i].timeStamp).Format('yyyy-MM-dd hh:mm:ss') }}</span>
          <span>{{item.content}}</span>
        </div>
        <div class="normal-msg" v-else>
          <p class="imTime" v-if="$store.state.notCompare[groupId][i]&&$store.state.notCompare[groupId][i].timeStamp">
          {{ new Date($store.state.notCompare[groupId][i].timeStamp).Format('yyyy-MM-dd hh:mm:ss') }}</p>
          <div class="isMe" v-if="item.isMe==1" style="text-align: right">
            <p class="IMname">{{ item.userName }}(本人)</p>
            <i v-if="item.loading" class="el-icon-loading"></i>
            <el-image v-if="item.type===1" style="width: 50px; height: 50px;vertical-align: bottom;" :src="item.content"
                      :preview-src-list="[item.content]"></el-image>
            <div @click="goHisVideo" class="content" v-else-if="item.type===9||item.type===30||item.type===31"><i
                slot="reference" class="pointer el-icon-video-camera-solid"></i>开启了视频通话
            </div>
            <video style="width: 300px;height: 200px;" controls="controls" v-else-if="item.type  === 12"
                  :src="item.content" alt=""></video>
            <div class="content" v-else> {{ item.content || '' }}</div>
            <el-avatar class="avatar m-left" shape="square" size="medium" :src="item.headImg"></el-avatar>
            <p class="read" v-if="item.messageId"> {{item.readCount}}人已读 <a style="color:#0B70FE;cursor:pointer"
                                                            @click="openReadRecord(item)">查看</a></p>
          </div>
          <div class="notMe" v-if="item.isMe==0">
            <p class="IMname">{{ item.userName }}</p>
            <div class="" style="display: flex;">
              <el-avatar class="avatar m-right" shape="square" size="medium" :src="item.headImg"></el-avatar>
              <el-image v-if="item.type===1" style="width: 50px; height: 50px" :src="item.content"
                        :preview-src-list="[item.content]"></el-image>
              <div @click="goHisVideo" class="content" v-else-if="item.type===9||item.type===30||item.type===31">开启了视频通话<i
                  slot="reference" class="pointer el-icon-video-camera-solid"></i></div>
              <m-audio v-else-if="item.type  === 13" :src="item.content"></m-audio>
              <video style="width: 300px;height: 200px;" controls="controls" v-else-if="item.type  === 12"
                    :src="item.content" alt=""></video>
              <div v-else class="content">{{ item.content || '' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="controlStrip">
      <div class="text-right operation" v-if="!forbiddenMsg">
        <el-upload
            ref='uploadFile'
            class="upload-demo"
            :action="publicAPI.uploadFile"
            multiple
            :limit="1"
            :on-success="handleSuccess"
            :file-list="fileList">
          <i class="pointer el-icon-folder"></i>
        </el-upload>
      </div>
      <div class="text-right operation" v-if="!forbiddenMsg">
        <i slot="reference" @click="onConfirm" class="pointer iconfont iconshipintonghua"></i>
        <!-- <el-popconfirm title="确定打开视频会议嘛？">
        </el-popconfirm> -->
      </div>
    </div>
    <div class="text-right">
      <el-input :disabled="forbiddenMsg" class="" style="width:100%" @keydown.native="listen($event)" v-model="content"
                type="textarea"
                row="5"></el-input>
      <el-button :disabled="forbiddenMsg" class="sendBut" @click="sendSock(5,1)">发送</el-button>
    </div>
    <!-- 线索视频弹窗 -->
    <el-dialog custom-class="video-log-box" :visible.sync="showVideoLog" :title="videoLogInfo.title"
               :before-close="closeVideoLog">
      <div class="video-log" v-if="videoLogInfo.list.length!=0">
        <div class="left-video">
          <video style="width: 100%;height: 500px;" controls="controls" :src="videoLogInfo.nowVideoSrc" alt=""></video>
        </div>
        <div class="right-list">
          <el-collapse v-model="videoLogInfo.activeUserIndex" accordion>
            <div v-for="(item,index) in videoLogInfo.list" :key="index">
              <el-collapse-item :title="item.realName" :name="index">
                <div :class="index==choosedIndex&&cindex==choosedcIndex?'active-log':''"
                     @click="changeVideo(cindex,index,citem.fileUrl,citem.createGmt)"
                     v-for="(citem,cindex) in item.intercomRes" :key="cindex">{{ citem.createGmt }}
                </div>
              </el-collapse-item>
            </div>
          </el-collapse>
        </div>
      </div>
      <div class="null-video" v-else>
        暂时没有视频线索哦！
      </div>
    </el-dialog>
    <!-- 视频弹窗 -->
    <el-dialog :visible.sync="chooseVideoType" title='选择视频会议类型' :before-close="closeChooseVideoType">
      <div class="video-type" style="display: flex;justify-content: center;">
        <div class="btn-item item1" @click='emerged'>
          <span class="iconfont iconzhibojianying"></span>
          <span>紧急会议</span>
        </div>
        <div class="btn-item item2" @click="normal">
          <span class="iconfont iconshipintonghua1"></span>
          <span>一般会议</span>
        </div>
        <div class="btn-item item3" @click="closeChooseVideoType">
          <span class="iconfont iconshibai"></span>
          <span>取消</span>
        </div>
      </div>
    </el-dialog>


    <!-- 消息已读未读 -->
    <el-dialog :visible.sync="checkRead" class="checkLog" :before-close="closeReadRecord"
               style="width: 330px;margin-left: 37%;">
      <div slot="title" class="header-title" :style="{'background': '#0B70FE', 'color': 'white'}">
        <div style="padding: 7px;font-family: emoji;font-size: 15px;">阅读列表</div>
      </div>

      <div style="border-bottom: 0px solid #eaf1f0;text-align: center;margin: -18px 1px;">
        <el-button :class="isChecked?'btn-cecked':''" type="primary" plain @click="checkWebChat(true)" style="margin-left: -33%">已读</el-button>
        <el-button :class="!isChecked?'btn-cecked':''" type="primary" plain  @click="checkWebChat(false)">未读</el-button>
      </div>

      <div style="margin-top: 60px">
        <div v-for="(item,i) in gridData" :key="i">
          <div style="border-bottom: 1px solid #eaf1f0;">
            <span><el-avatar class="avatar m-left" shape="square" size="medium" :src="item.portrait"></el-avatar></span>
            <span style="line-height: 40px;color: #a7a7a7;margin-left: 10px">{{ item.realName }}</span>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import publicAPI from '../../api-path/public-api'
import publicFn from '../../assets/js/publicFn'
import {mapAPI, listAPI} from '../../api-path/command-center';

export default {
  name: "webSrom",
  props: {
    groupId: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: 200,
    },
    date: {
      type: Number,
      default: new Date().getTime(),
    },
    size: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    createTime: {
      type: String,
      default: '暂无时间',
    },
    textTitle: {
      type: String,
      default: '聊天'
    }
  },
  data() {
    return {
      publicAPI,
      isRealTime: false,
      chooseVideoType: false,
      checkRead: false,
      userId: '', //自定义id
      checkId: '',
      notCompare: {}, //发出的所有消息
      content: '',
      askSize: 20,
      getUnread: [],
      proto: null,
      messagesContainerTimer: null,
      groupMember: [],//聊天成员
      hasMoreInfo: true,//是否还有更多消息
      clickMore: false,
      forbiddenMsg: false,//是否禁止发送消息
      showVideoLog: false,//是否显示视频线索弹窗
      videoLogInfo: {
        title: '线索视频',
        nowVideoSrc: '',
        activeUserIndex: 0,
        list: []
      },
      choosedIndex: '',
      choosedcIndex: "",
      //新增
      fileList: [],
      fileUrl: '',

      groupReadId: '',
      messageReadId: '',
      gridData: [],
      isChecked:true,
    }
  },
  computed: {
    listData() {
      return this.$store.state.notCompare
    },
    isForbidden() {
      return this.$store.state.isForbidden
    }
  },
  watch: {
    listData(newVal) {
      // 数据变化后，调用b组件内的函数
      newVal[this.groupId].map(item => {
        item.userName = this.setUserName(item.sendUserId);
        item.headImg = this.setHeadImg(item.sendUserId);
      })
      this.notCompare = newVal;
      if (!this.clickMore) {
        this.Talk()
      }
    },
    isForbidden(newVal) {
      this.forbiddenMsg = newVal;
    }
  },
  created() {
    let href = window.location.href.split('#')[1];
    if (href == '/visual-intercom/real-time-intercom') {//可视对讲
      this.isRealTime = true;
    } else {
      this.isRealTime = false;
    }
    this.getData()
    if (this.size > 0) {
      this.groupHistoryMessage(this.date, this.size);
    }
    this.forbiddenMsg = this.disabled;
    this.sendSock(9, 3)
  },
  beforeDestroy() {
    this.$store.commit('setIsForbidden', false);
  },
  methods: {
    handleSuccess(file, fileList) {
      if (file.status == 200) {
        this.fileUrl = file.result.url;
        if (file.result.suffixType == 1) {//图片
          this.sendSock(5, 1, 1)
        } else if (file.result.suffixType == 12) {
          this.sendSock(5, 1, 12)
        }
        this.$nextTick(() => {
          this.$refs.uploadFile.clearFiles();
        })
      }
    },
    //紧急会议
    emerged() {
      this.sendSock(5, 1, 31);
      this.$http.get(`${publicAPI.getAlarmStream}?alarmId=${this.groupId}`).then(res => {
        if (res.status === 200) {
          if (window.QCefClient) {
            res.result.type = 3
            res.result.userId = sessionStorage.getItem('userId')
            window.QCefClient.invokeMethod('QCef_Open_Player', 3, false, JSON.stringify(res.result))
          }
        }
      })
      this.chooseVideoType = false;
    },
    //一般会议
    normal() {
      this.sendSock(5, 1, 30);
      this.$http.get(`${publicAPI.getAlarmStream}?alarmId=${this.groupId}`).then(res => {
        if (res.status === 200) {
          if (window.QCefClient) {
            res.result.type = 3
            res.result.userId = sessionStorage.getItem('userId')
            window.QCefClient.invokeMethod('QCef_Open_Player', 3, false, JSON.stringify(res.result))
          }
        }
      })
      this.chooseVideoType = false;
    },
    closeChooseVideoType() {
      this.chooseVideoType = false;
    },
    goHisVideo() {//直接进入
      this.$http.get(`${publicAPI.getAlarmStream}?alarmId=${this.groupId}`).then(res => {
        if (res.status === 200) {
          if (window.QCefClient) {
            res.result.type = 3
            res.result.userId = sessionStorage.getItem('userId')
            window.QCefClient.invokeMethod('QCef_Open_Player', 3, false, JSON.stringify(res.result))
          }
        }
      })
    },
    //获取视频日志
    getVideoLog() {
      this.$http.get(listAPI.alarmIntercom, {params: {alarmId: this.groupId}}).then(res => {
        if (res.status == 200) {
          if (res.result && res.result.length != 0) {
            this.showVideoLog = true;
            this.videoLogInfo.list = res.result;
            this.videoLogInfo.title = res.result[0].intercomRes[0].createGmt;
            this.videoLogInfo.nowVideoSrc = res.result[0].intercomRes[0].fileUrl;
          } else {

            this.showVideoLog = true;
          }
          // title:'线索视频',
          // nowVideoSrc:'',
          // activeUserIndex:0,
        }
      })
    },
    //changeVideo
    changeVideo(cindex, index, url, title) {
      this.choosedcIndex = cindex;
      this.choosedIndex = index;
      this.videoLogInfo.title = title;
      this.videoLogInfo.nowVideoSrc = url;
    },
    //关闭视频日志
    closeVideoLog() {
      this.showVideoLog = false;
      this.videoLogInfo.list = [];
      this.videoLogInfo.title = '';
      this.videoLogInfo.nowVideoSrc = '';
    },
    //回车禁止换行
    listen(event) {
      if (event.keyCode === 13) {
        this.sendSock(5, 1) // 发送文本
        event.preventDefault() // 阻止浏览器默认换行操作
        return false
      }
    },
    //获取群成员
    getData() {
      const $this = this;
      this.$http.get(mapAPI.getGroupUserInfo + '?groupId=' + this.groupId).then(res => {
        if (res.status === 200) {
          this.groupMember = res.result;
          let notGroupMember = JSON.parse(JSON.stringify($this.$store.state.notGroupMember));
          notGroupMember[this.groupId] = res.result;
          this.$store.commit('setGroupMember', notGroupMember);
        }
      })
    },
    //发送消息
    sendSock(cmd, msgtype, type) { //请求接口命令字1绑定2心跳,3上线,4下线,5消息,6重连,7群通知,8客户端收到消息确认,9消息已读确认;
      if (this.content === '' && !type) {
        return
      }
      let data = {
        cmd: cmd,
        groupId: this.groupId, //用户组编号
        sendUserId: sessionStorage.getItem('userId'),
        checkid: publicFn.uuidGenerator(),
        type: type,
        headImg: this.setHeadImg(sessionStorage.getItem('userId')),
        content: {
          content: (type == 1 || type == 12) ? this.fileUrl : this.content,
        }, //请求数据
      }
      if (msgtype) {
        data.msgtype = msgtype;
      }
      if (type) {
        data.content.type = type
      }
      let getTime = new Date().getTime()
      let isMe = {
        isMe: 1,
        loading: true,
        timeStamp: getTime
      }
      publicFn.sendMsg(data);
      let newData = JSON.parse(JSON.stringify(data));
      newData.content = (type == 1 || type == 12) ? this.fileUrl : this.content;
      this.content = '';
      this.clickMore = false;
      //数据添加到数据中
      this.listPushData({
        ...newData,
        ...isMe
      })
    },
    //时间转换
    formatMsgTime(dateTimeStamp) {
      let minute = 1000 * 60;
      let hour = minute * 60;
      let day = hour * 24;
      // let halfamonth = day * 15;
      let month = day * 30;
      let now = new Date().getTime();
      let diffValue = now - dateTimeStamp;
      if (diffValue < 0) {
        return;
      }
      let monthC = diffValue / month;
      let weekC = diffValue / (7 * day);
      let dayC = diffValue / day;
      let hourC = diffValue / hour;
      let minC = diffValue / minute;
      let result = ''
      if (monthC >= 1) {
        result = "" + parseInt(monthC) + "月前";
      } else if (weekC >= 1) {
        result = "" + parseInt(weekC) + "周前";
      } else if (dayC >= 1) {
        result = "" + parseInt(dayC) + "天前";
      } else if (hourC >= 1) {
        result = "" + parseInt(hourC) + "小时前";
      } else if (minC >= 1) {
        result = "" + parseInt(minC) + "分钟前";
      } else
        result = "刚刚";
      return result;
    },
    //获取消息
    groupHistoryMessage(date, size) {
      let $this = this;
      let groupId = this.groupId;
      let params = {
        date: date || new Date().getTime(),
        size: size || 20,
        groupId: groupId,
      }
      this.$http.get(publicAPI.HistoryGroupMsg, {
        params: params
      }).then(res => {
        if (res.status == 200) {
          if (res.result && res.result.length) {
            let result = [];
            res.result.forEach(item => {
              result.push({
                sendUserId: item.sendUserId,
                type: item.type,
                timeStamp: item.createGmt,
                content: item.content,
                isMe: item.isMe,
                messageId: item.id,
                headImg: item.headImg,
                groupId: item.groupId,
                readCount:item.readCount
              })
            })

            let notCompare = JSON.parse(JSON.stringify($this.$store.state.notCompare));
            if (notCompare && notCompare[groupId]) {
              let oldLen = notCompare[groupId].length;
              notCompare[groupId] = [...result, ...notCompare[groupId]];
              notCompare[groupId] = this.peonArr(notCompare[groupId]);
              let newLen = notCompare[groupId].length;
              this.hasMoreInfo = oldLen === newLen ? false : true;
            } else {
              notCompare[groupId] = result;
            }
            this.$nextTick(() => {
              $this.$store.commit('changeData', notCompare);
            })

          } else {
            // this.$message.error('没有更多消息了')
            this.hasMoreInfo = false;
          }
        }
      })
    },
    //发送推送消息到列表
    listPushData(data) {
      let $this = this;
      let notCompare = JSON.parse(JSON.stringify(this.$store.state.notCompare));
      let groupId = this.groupId;
      if (notCompare[groupId] && notCompare[groupId].length > 0) {
        let newData = [...notCompare[groupId], ...[data]];
        notCompare[groupId] = newData;
      } else {
        notCompare[groupId] = [];
        notCompare[groupId] = [data]
      }
      this.$nextTick(() => {
        this.notCompare = notCompare;
        $this.$store.commit('changeData', notCompare);
        this.Talk()
      })
    },
    setHeadImg(sendUserId) {
      let result = '';
      this.groupMember.map(item => {
        if (item.id == sendUserId) {
          result = item.portrait;
        }
      })
      return result;
    },
    setUserName(sendUserId) {
      let result = '';
      this.groupMember.map(item => {
        if (item.id == sendUserId) {
          result = item.realName;
        }
      })
      return result;
    },
    //判断是否是本人
    isMe(userId) {
      if (userId == sessionStorage.getItem('userId')) {
        return 1
      } else {
        return 0
      }
    },
    messageHistory() {
      this.clickMore = true;
      let groupId = this.groupId;
      let date
      if (this.notCompare[groupId] && this.notCompare[groupId].length > 0) {
        if (this.createGmt) {
          date = this.createGmt;
        } else {
          date = this.notCompare[groupId][0].timeStamp;
        }
      } else {
        date = new Date().getTime();
      }
      this.groupHistoryMessage(date, 20)
    },
    peonArr(list) {
      let data = []
      list.forEach(item => data.push(JSON.stringify(item)))
      data = Array.from(new Set(data))
      data.forEach((item, index) => {
        data[index] = JSON.parse(item)
      })
      return data
    },
    //滚动条滚到底
    Talk() {
      this.messagesContainerTimer = setTimeout(() => {
        this.$refs.chatFrame.scrollTop = this.$refs.chatFrame.scrollHeight;
        clearTimeout(this.messagesContainerTimer); // 清理定时器
      }, 0);

    },
    //清空信息  应该清空当前群组信息信息
    ClearChatLogs() {
      this.notCompare = {};
    },
    //视频会议
    onConfirm() {
      let href = window.location.href.split('#')[1];
      if (href == '/visual-intercom/real-time-intercom') {//可视对讲
        this.chooseVideoType = true;
      } else {
        this.$confirm('确定打开视频会议嘛?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.sendSock(5, 1, 9)
          this.$http.get(`${publicAPI.getAlarmStream}?alarmId=${this.groupId}`).then(res => {
            if (res.status === 200) {
              if (window.QCefClient) {
                res.result.type = 3
                res.result.userId = sessionStorage.getItem('userId')
                window.QCefClient.invokeMethod('QCef_Open_Player', 3, false, JSON.stringify(res.result))
              }
            }
          })
        }).catch(() => {

        });
      }
    },


    //查看消息的已读未读

    checkPrimary(){
      return {
        active: this.isActive,
        'type': 'primary'
      }
    },

    openReadRecord(item) {

      console.log("---------------->" + JSON.stringify(item))
      this.groupReadId = item.groupId;
      this.messageReadId = item.messageId;
      this.checkRead = true;
      this.isChecked=true;
      this.checkWebChat(true);
    },
    checkWebChat(isRead) {
      this.isChecked=isRead;
      const checkInfo = {
        groupId: this.groupReadId,
        messageId: this.messageReadId,
        isRead: isRead
      };

      this.$http.get(`${publicAPI.getReadOrNotRead}`, {params: checkInfo}).then(res => {
        if (res.status === 200) {
          this.gridData = res.result;
        }
      })
    },
    closeReadRecord() {
      this.checkRead = false;
    },


    uploadVerification(e) { //打开上传
      console.log(e)
    },
  },
}
</script>

<style lang="less">


.webSrom {
  .btn-cecked{
    background: #409EFF !important;
    border-color: #409EFF !important;
    color: #FFF !important;
  }

  .read{
    margin-left: 73%;
    font-size: 13px;
  }


  //-----------已读未读查询
  .checkLog {
    .el-dialog__headerbtn .el-dialog__close {
      color: #e0e4ea;
    }

    .el-dialog__header {
      padding: 0px 0px 0px;
    }
    .header-title{
      height: 33px;
    }
    .el-dialog__headerbtn {
      top: 10px;
      right: 10px;
    }
    .el-button{
      font-size: 10px;
      width: 120px;
      border-radius: 0px;
      position: absolute;
    }
    .el-dialog__body{
      padding: 30px 0px;
    }
    .el-dialog {
      width: 140%;
      height: 50%;
      margin-top: 0vh;
    }
  }


  .el-upload-list {
    display: none;
  }

  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;

  .video-type {
    .btn-item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin: 0 20px;
      padding: 10px;
      cursor: pointer;
      font-size: 14px;

      .iconfont {
        margin-bottom: 20px;
        font-size: 25px;
      }
    }

    .item1 {
      color: #F56C6C;
    }

    .item2 {
      color: #33CC66;
    }

    .item3 {
      color: #ccc;
    }
  }

  .IMtop {
    height: 50px;
    padding: 10px;
    // line-height: 20px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 5px 5px 0 0;
    border: 1px solid #d3d3d0;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .history-btn {
      color: #4f7ce3;
      position: absolute;
      cursor: pointer;
      padding: 5px 10px;
      border-radius: 5px;
      background: #d8e8f9;
      font-size: 14px;
      right: 20px;

      &:hover {
        background: #0B70FE;
        color: #fff;
      }
    }
  }

  .isMe {
    text-align: right;
    margin-top: 5px;

    .read {
      color: #999999;
    }

    .content {

      padding: 10px;
      background: #d8e8f9;
      border-radius: 5px;
      word-wrap: break-word;
      width: auto;
      display: inline-block;
      max-width: 90%;
      position: relative;
      right: 0;

      &:before {
        display: block;
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        right: -6px;
        top: 14px;
        border-top: solid 6px transparent;
        border-left: 6px solid #d8e8f9;
        border-bottom: solid 6px transparent;
      }

      .el-icon-video-camera-solid {
        margin-right: 5px;
        font-size: 18px;
      }
    }
  }

  .notMe {
    margin-top: 5px;
    text-align: left;

    .content {
      padding: 10px;
      background: #e8e8e8;
      border-radius: 5px;
      width: auto;
      display: inline-block;
      max-width: 90%;
      word-wrap: break-word;

      &:before {
        display: block;
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        left: -6px;
        top: 14px;
        border-top: solid 6px transparent;
        border-right: 6px solid #e8e8e8;
        border-bottom: solid 6px transparent;
      }

      .el-icon-video-camera-solid {
        margin-left: 5px;
        font-size: 18px;
      }
    }
  }

  .chatFrame {
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
    // min-height: 200px;
    flex: 1;
    overflow-y: auto;
    /*border:1px solid #d3d3d0 ;*/
    border-top: 0;
    .other-msg{
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px 0;
      font-size: 12px;
      color: #999;
    }
    .MoreNews {
      color: #d3d3d0;
      font-size: 12px;
      margin-bottom: 10px;
      display: inline-block;

      &:hover {
        color: #00a0e9;
      }
    }

    .imTime {
      text-align: center;
      color: #b8b8b5;
      margin: 10px 0;
      font-size: 14px;
    }

    .IMname {
      font-size: 10px;
      margin-bottom: 10px;
    }

  }

  .controlStrip {
    padding: 5px;
    display: flex;
    align-self: flex-end;

    .text-right {
      i {
        margin: 0 5px;
        font-size: 28px;

        &:hover {
          color: #00a0e9;
        }
      }
    }
  }

  .sendBut {
    margin: 10px 0;
  }

  .m-right {
    margin-right: 10px;
  }

  .m-left {
    margin-left: 10px;
  }

  .avatar {
    vertical-align: middle;

  }

  .operation {
    .el-button {
      border: 0;
      padding: 0;

      &:hover {
        color: #409EFF;
        background: none !important;
      }
    }

  }

  .video-log-box {
    .null-video {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 500px;
    }

    background: #222222;

    .el-dialog__body {
      padding: 0;
    }

    .el-dialog__title {
      color: #fff;
      display: flex;
      justify-content: center;
    }

    .el-collapse-item {
      background: #222222;

      .el-collapse-item__content {
        padding-bottom: 0;

        > div {
          color: #999;
          cursor: pointer;
          padding: 10px;
        }

        .active-log {
          color: #fff;
          background-color: #124477;
        }
      }
    }

    .is-active {
      color: #fff;
    }

    .el-collapse {
      border-top: 0;
    }

    .el-dialog__header {
      padding: 20px;
      background: linear-gradient(0deg, black, #04223e);

      .el-dialog__close {
        font-size: 25px;
      }
    }

    .el-collapse-item__header {
      background-color: #222222;
      color: #fff;
      border-bottom: 0;
    }

    .el-collapse-item__wrap {
      background-color: #222222;
      border-bottom: 0;
    }

    .video-log {
      display: flex;

      .left-video {
        flex: 1;
        background: #000;
      }

      .right-list {
        width: 200px;
        // margin-left: 20px;
        height: 500px;
        padding: 0 10px;
        box-sizing: border-box;
        overflow-y: auto;
      }
    }
  }

}
</style>
